import { render, staticRenderFns } from "./ProductGrid.vue?vue&type=template&id=1bf59312&scoped=true&"
import script from "./ProductGrid.vue?vue&type=script&lang=js&"
export * from "./ProductGrid.vue?vue&type=script&lang=js&"
import style0 from "./ProductGrid.vue?vue&type=style&index=0&id=1bf59312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf59312",
  null
  
)

/* custom blocks */
import block0 from "./ProductGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VChip,VIcon,VImg})
